<template>
  <div class>
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>Commandes clients</v-toolbar-title>
    </v-toolbar>

    <v-tabs v-model="tab">
      <v-tabs-slider></v-tabs-slider>
      <v-tab>Commandes à valider</v-tab>
      <v-tab>Commandes en cours</v-tab>
      <v-tab>Commandes terminées</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card elevation="0">
          <v-card-text>
            <order-list :orders="orderToValidate" />
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card elevation="0">
          <v-card-text>
            <order-list :orders="orderInProcess" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card elevation="0">
          <v-card-text>
            <order-list :orders="orderFinished" />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import OrderList from "../../components/order/List";
import { mapState } from "vuex";

export default {
  components: {
    OrderList
  },
  data: function() {
    return {
      tab: null
    };
  },
  computed: {
    ...mapState("order", {
      orders: state => state.list
    }),
    orderToValidate() {
      return this.orders.filter(order => ["paid"].includes(order.status));
    },
    orderInProcess() {
      return this.orders.filter(order =>
        ["sent", "confirmed", "waiting"].includes(order.status)
      );
    },
    orderFinished() {
      return this.orders.filter(order =>
        ["delivered", "toBeReviewed"].includes(order.status)
      );
    }
  },
  mounted: function() {
    this.getOrder();
  },
  methods: {
    getOrder() {
      this.$store.dispatch("order/list");
    }
  }
};
</script>

<style>
</style>